export default __webpack_public_path__ + "static/media/KIOSK_IKONA.8ed3f56a.png";